import { render, staticRenderFns } from "./Sidemenu.vue?vue&type=template&id=30830bbc&"
import script from "./Sidemenu.vue?vue&type=script&lang=js&"
export * from "./Sidemenu.vue?vue&type=script&lang=js&"
import style0 from "./Sidemenu.vue?vue&type=style&index=0&id=30830bbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports